import styled from 'styled-components'

import { Colors, mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;
  background: ${Colors.GS200};
  flex-direction: column;

  ${mediaQueries.tablet} {
    flex-direction: row;
  }
`
